module.exports = "/deep/ .mat-autocomplete-panel {\n  min-width: 350px !important; }\n\n.mat-error {\n  font-size: 75%; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared-components/chip-autocomplete/chip-autocomplete.component.scss
// module id = ./src/app/shared-components/chip-autocomplete/chip-autocomplete.component.scss
// module chunks = main